import Transactions from './transactions'

export default () => {
    return <Transactions />
}
